/**
 * @name setDrawerButton
 * @description ドロワーナビの開閉
 * @param {Object} html html要素
 * @param {Object} DrawerButton ドロワーボタン要素
 * @param {Object} Links アンカーリンク
 */
export function setDrawerButton() {
  let html = document.querySelector('html');
  let header = document.querySelector('.header');
  let drawerNav = document.querySelector('.drawerNav');
  let DrawerButton = document.querySelector('.drawerButton-el');
  let Links = document.querySelectorAll('a[data-anchor="true"]');
  if (!DrawerButton) return;

  /**
   * @name navOpen
   * @description ドロワーナビを開く
   */
  const navOpen = () => html.dataset.state = "navOpen";

  /**
   * @name navClose
   * @description ドロワーナビを閉じる
   */
  const navClose = () => html.dataset.state = "";

  /**
   * @name getHeadClientRect
   * @description 画面上部からのスクロール量を取得し、ヘッダーの位置を調整する
  */
  const getHeadClientRect = () => {
    let rectPosTop = header.getBoundingClientRect().top;
    let rectHeight = header.getBoundingClientRect().height;
    header.style.setProperty('--rect-pos-top', `-${rectPosTop}px`);
    drawerNav.style.setProperty('--h-height', `${rectHeight}px`);
  }

  // ドロワーボタンクリック時
  DrawerButton.addEventListener("click", () => {
    getHeadClientRect();
    html.dataset.state === "navOpen" ? navClose() : navOpen()
  });

  // アンカーリンククリック時
  Links.forEach((link) => link.addEventListener("click", navClose))
};